import { gql } from 'apollo-angular';

export const GET_CROSSES = gql`
  query getCrosses($searchValue: String!, $categoryId: Long!) {
    optimizedPurchasedProducts(
      searchCriteria: {
        limit: 50
        searchValue: $searchValue
        boostCriteria: { fieldName: "categoryId", fieldValue: $categoryId }
      }
    ) {
      id
      catalogNumber
      description
      status
      packageString
      productSource
      categories {
        id
        name
        parents {
          id
          name
        }
      }
      seller {
        id
        name
      }
      sysSeller {
        id
        name
      }
    }
  }
`;

export default GET_CROSSES;
